import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Payment, Transaction } from '../../models';
import { environment } from '../../../environments/environment';
import { AlertService } from '../../services/alert.service';
import { DepositComponent } from '../deposit/deposit.component';
import { TransferComponent } from '../transfer/transfer.component';
import { ALERT_ICON_CONSTANTS, BANNER_MESSAGES, FLAGS_NAME, GENERAL_CONSTANTS } from '../../core/constants/General-constants';
import { BANK_IDS, PAY_METHODS_CR } from '../../core/constants/payMethods-cr';
import { CONCEPTS } from '../../core/constants/Concepts';
import { FormControl, Validators } from '@angular/forms';
import { PATTERN } from '../../constants/pattern';
import { UserDataModel } from '../../models/userData.model';
import { SubMenuService } from 'src/app/services/sub-menu.service';
import { TokenServiceService } from 'src/app/services/token-service.service';
import { CONSTANTS } from 'src/app/constants/users.constants';
import { RequestUpdateUserName } from 'src/app/models/requestUpdateUserName';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';
import { PaymentMethodsService } from 'src/app/services/payment-methods.service';
import { GeneralTool } from '../split-payment/tools/general-tools';
import { ALERT_BUTTONS_MESSAGES } from 'src/app/core/constants/AlertMessages';
import { SweetAlertIcon } from 'sweetalert2';
@Component({
    selector: 'app-sub-menu-cr',
    templateUrl: './sub-menu.component.html',
    styleUrls: ['./sub-menu.component.scss'],
})
export class SubMenuComponent implements OnInit {
    @Input() text: string;
    @Input() subText: string;
    @Input() paymentsSubMenu: Payment[];
    @Input() transaction: Transaction;
    @Input() visibleReturnPayMethods: boolean;
    @Input() flagActive: boolean;
    @Output() outPutSubMenuEmitter = new EventEmitter();

    @ViewChild(DepositComponent) deposit: DepositComponent;
    @ViewChild(TransferComponent) transfer: TransferComponent;
    formPrivacyValid: boolean;
    fullName: string = '';
    merchantHasWallet: boolean;

    bannerText: string;
    bannerRecommedationFF: boolean = false;
    bannerRecommedationUiFixFF: boolean = false;

    constructor(
        private readonly alertService: AlertService,
        private readonly subMenuService: SubMenuService,
        private readonly tokenServiceService: TokenServiceService,
        private readonly paymentMethodsService: PaymentMethodsService,
        private featureFlagService: PayvalidaFeatureFlagService
    ) {}

    loading: boolean;
    valid = false;
    logo: string;
    visualizeSubMenu = true;
    visualizeUserForm = false;
    visualizePayWeb = false;
    visualizeCash = false;
    visualizeDeposit = false;
    visualizeTransfer = false;
    checkbox = false;
    payment: Payment;
    readonly paymentsMethods = PAY_METHODS_CR;
    readonly bankIds = BANK_IDS;
    readonly CONCEPTS = CONCEPTS;
    public enableContinue = false;
    public userDataModel: UserDataModel;
    buttonEnabledInSubMenu: boolean = false;

    fullNameFormControl = new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(50), Validators.pattern(PATTERN.CHARACTERS_SPACE_CHARACTERS)]);

    ngOnInit() {
        const token = this.tokenServiceService.getToken();

        this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.BANNER_RECOMMENDATION_UI_FIX, FLAGS_NAME.BANNER_RECOMMENDATION_UI_FIX).subscribe((response: boolean) => {
            this.bannerRecommedationUiFixFF = response;
        });

        this.paymentMethodsService.paymentMethods(token).subscribe((data: any) => {
            const merchantHasWallet = GeneralTool.checkMerchantHasWallet(data);

            if (merchantHasWallet) {
                this.merchantHasWallet = true;
            }
        });

        this.userDataModel = new UserDataModel();
        this.visualizeUserForm = this.flagActive && !this.transaction.USER_NAME;

        this.paymentsSubMenu.sort((x, y) => x[GENERAL_CONSTANTS.PRIORITY] - y[GENERAL_CONSTANTS.PRIORITY]);

        for (let payment of this.paymentsSubMenu) {
            this.featureFlagService.getFeatureFlagValue(`${payment.code}_rc_banners`, FLAGS_NAME.RECOMMENDATIONS_BANNER_FF).subscribe((response: boolean) => {
                this.bannerRecommedationFF = response;
            });
            switch (payment.code) {
                case BANK_IDS.BNCR_PAY_WEB:
                case BANK_IDS.BNCR_DEPOSIT:
                case BANK_IDS.BNCR_TRANSFER:
                    this.logo = environment.logo_bn_cr;
                    break;
                case BANK_IDS.BCR_DEPOSIT:
                case BANK_IDS.BCR_TRANSFER:
                    this.logo = environment.logo_bcr;
                    break;
                case BANK_IDS.LAFISE_TRANSFER:
                    this.logo = environment.logoLafiseBank;
                    break;
            }
        }
    }

    /**
     * @description changeMethod Function to switch to view of payment methods
     */
    changeMethod() {
        this.outPutSubMenuEmitter.emit();
    }

    /**
     * @description in charge of controlling which view the sub-menu directs to
     * @param payment user selected payment method information
     */
    methods(payment: Payment) {
        this.payment = payment;
        this.visualizeSubMenu = false;
        switch (payment.code) {
            case this.bankIds.BNCR_PAY_WEB:
                this.visualizeDeposit = false;
                this.visualizePayWeb = true;
                this.visualizeTransfer = false;
                this.visualizeCash = false;
                break;
            case this.bankIds.BNCR_CASH:
                this.visualizeDeposit = false;
                this.visualizePayWeb = false;
                this.visualizeTransfer = false;
                this.visualizeCash = true;
                this.bannerText = BANNER_MESSAGES.CASH_RECOMMENDATION;
                break;
            case this.bankIds.BNCR_DEPOSIT:
                this.visualizeDeposit = true;
                this.visualizePayWeb = false;
                this.visualizeTransfer = false;
                this.visualizeCash = false;
                this.bannerText = BANNER_MESSAGES.DEPOSIT_RECOMENDATION;
                break;
            case this.bankIds.BCR_DEPOSIT:
                this.visualizeDeposit = true;
                this.visualizePayWeb = false;
                this.visualizeTransfer = false;
                this.visualizeCash = false;
                this.bannerText = BANNER_MESSAGES.DEPOSIT_RECOMENDATION;
                break;
            case this.bankIds.BNCR_TRANSFER:
                this.visualizeDeposit = false;
                this.visualizePayWeb = false;
                this.visualizeTransfer = true;
                this.visualizeCash = false;
                this.bannerText = BANNER_MESSAGES.DEPOSIT_RECOMENDATION;
                break;
            case this.bankIds.BCR_TRANSFER:
                this.visualizeDeposit = false;
                this.visualizePayWeb = false;
                this.visualizeTransfer = true;
                this.visualizeCash = false;
                this.bannerText = BANNER_MESSAGES.DEPOSIT_RECOMENDATION;
                break;
            case this.bankIds.LAFISE_TRANSFER:
                this.visualizeDeposit = false;
                this.visualizePayWeb = false;
                this.visualizeTransfer = true;
                this.visualizeCash = false;
                this.bannerText = BANNER_MESSAGES.DEPOSIT_RECOMENDATION;
                break;
            default:
                this.alertService.showAlertProblem();
                break;
        }
    }

    /**
     * @description send email to user
     */
    finalize() {
        switch (this.payment.code) {
            case this.bankIds.BNCR_DEPOSIT:
            case this.bankIds.BCR_DEPOSIT:
                this.deposit.sendEmail();
                break;
            case this.bankIds.LAFISE_TRANSFER:
            case this.bankIds.BNCR_TRANSFER:
            case this.bankIds.BCR_TRANSFER:
                this.transfer.sendEmail();
                break;
            default:
                this.alertService.showPopup(
                    ALERT_BUTTONS_MESSAGES.THANKS,
                    CONSTANTS.EXPIRATION_MESSAGE_PART_ONE + this.transaction.EXPIRATION + CONSTANTS.EXPIRATION_MESSAGE_PART_TWO,
                    ALERT_ICON_CONSTANTS.SUCCESS as SweetAlertIcon,
                    CONSTANTS.ALERT_SERVICE_BUTTON_ACCEPT
                );
                break;
        }
    }

    /**
     * @description helper function that helps to know about form events
     */
    setInfo(concept) {
        if (concept === CONCEPTS.TRANSFER) {
            this.transfer.emailForm.valueChanges.subscribe((_) => this.checkForms());
            this.transfer.copiesComponents.forEach((c) =>
                c.onCopy.subscribe(() => {
                    this.checkForms();
                })
            );
        }
        if (concept === CONCEPTS.DEPOSIT) {
            this.deposit.emailForm.valueChanges.subscribe((_) => this.checkForms());
        }
    }

    /**
     *
     * @description {formPrivacyUpdate} Function that obtains the event of the validation of the child component
     * @param valid
     */
    formPrivacyUpdate = (valid: boolean) => {
        this.formPrivacyValid = valid;
        this.fullName = this.fullNameFormControl.value;
        if (valid && this.fullNameFormControl.valid) {
            this.loading = true;
            this.updateUserNameInOrder(this.fullName);
        }
    };

    /**
     *
     * @description {completedForms} Function to validate the validations of the parent component and child component
     * @returns
     */
    completedForms = (): boolean => {
        return this.formPrivacyValid && this.fullName !== '' && this.fullNameFormControl.valid;
    };

    /**
     * @description Verify that the form has been filled out correctly
     */
    checkForms() {
        if (this.bankIds.BNCR_DEPOSIT === this.payment.code || this.bankIds.BCR_DEPOSIT === this.payment.code) {
            this.valid = this.deposit.emailForm.valid;
        } else if (this.bankIds.BNCR_TRANSFER === this.payment.code || this.bankIds.BCR_TRANSFER === this.payment.code || this.bankIds.LAFISE_TRANSFER) {
            this.valid = this.transfer.emailForm.valid;
        }
    }

    /**
     *
     * @description {updateUserNameInOrder} Function to update the username of the order
     * @param userFullName user's full name
     */
    updateUserNameInOrder(userFullName: string) {
        let requestBody: RequestUpdateUserName = { UserName: userFullName };
        this.subMenuService.updateUserNameInOrder(this.tokenServiceService.getToken(), requestBody).subscribe((response) => {
            this.enableContinue = response.CODE == CONSTANTS.CODE_OK;
            this.loading = false;
        });
    }

     /**
   *
   * @description {handleButtonStateChange} Function to update the send button if the validations are valid
   * @param enabled event
   */
  handleButtonStateChange(enabled: boolean) {
    this.buttonEnabledInSubMenu = enabled;
  }
}
